import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  Title,
  Tooltip,
  TimeScale,
  Filler,
  Legend,
} from "chart.js";
import "chartjs-adapter-date-fns";

ChartJS.register(
  LineElement,
  PointElement,
  LinearScale,
  TimeScale,
  Title,
  Tooltip,
  Filler,
  Legend
);

export default function ScatterChart({ data }) {
  const chartData = {
    datasets: [
      {
        label: "Bids Over Time",
        data: data.map(item => ({
          x: new Date(item.date),
          y: item.count,
        })),
        fill: false,
        borderColor: "#088e92",
        backgroundColor: "#003b47",
        tension: 0.2,
      },
    ],
  };

  const options = {
    responsive: true,
    scales: {
      x: {
        type: "time",
        time: {
          unit: "day",
        },
        title: {
          display: true,
          text: "Date",
        },
      },
      y: {
        title: {
          display: true,
          text: "Number of Bids",
        },
        beginAtZero: true,
      },
    },
  };

  return (
    <div className="chartCard">
      <h3>Bids Received Over Time</h3>
      <Line data={chartData} options={options} />
    </div>
  );
}
